import React, { useState } from "react";
import { Bell } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { SEASONS } from "@/lib/seasons";

export const seasonOf = (slug) => SEASONS.find((s) => s.slug === slug) || { label: "this collection", emoji: "✨" };

export async function requestSneakPeekReminder({ email, product, joinPack = false }) {
  return api.post("/seasons/notify", { email, slug: product.seasonal, product_id: product.id, join_pack: joinPack });
}

export function reminderToast(product) {
  const s = seasonOf(product.seasonal);
  toast.success(`${s.emoji} We'll email you the moment ${product.name} opens with the ${s.label} collection`);
}

export default function SneakPeekRemindDialog({ open, onOpenChange, product }) {
  const [email, setEmail] = useState("");
  const [joinPack, setJoinPack] = useState(true);
  const [busy, setBusy] = useState(false);
  const s = seasonOf(product?.seasonal);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await requestSneakPeekReminder({ email: email.trim(), product, joinPack });
      reminderToast(product);
      onOpenChange(false);
      setEmail("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl bg-[#FFF9EE] border-0 max-w-md" data-testid="sneak-peek-dialog">
        <DialogTitle className="font-display font-extrabold text-xl text-[#19324A] flex items-center gap-2"><Bell className="w-5 h-5 text-[#FF6B9D]" /> Get a nudge when it opens</DialogTitle>
        <DialogDescription className="text-sm text-[#19324A]/70">
          <strong className="text-[#19324A]">{product?.name}</strong> lands with the {s.label} collection {s.emoji}. Pop your email in and we'll let you know the moment it's ready to order.
        </DialogDescription>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" autoComplete="email"
            className="w-full rounded-xl border-2 border-[#19324A]/10 bg-white px-4 py-3 text-sm outline-none focus:border-[#FF6B9D]" data-testid="sneak-peek-email" />
          <label className="flex items-start gap-2 text-xs text-[#19324A]/75">
            <input type="checkbox" checked={joinPack} onChange={(e) => setJoinPack(e.target.checked)} className="mt-0.5 w-4 h-4 accent-[#FF6B9D]" data-testid="sneak-peek-join-pack" />
            Also join the Pack for 24-hour early access and the odd treat. Unsubscribe any time.
          </label>
          <button type="submit" disabled={busy} className="btn-pink w-full disabled:opacity-60" data-testid="sneak-peek-submit">{busy ? "Saving…" : "Remind me"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
